import React, {
  useCallback,
} from "react";
import PropTypes from "prop-types";

import {
  assertDockPanelRegistry,
  DOCK_NODE_TYPES,
} from "../../../engines/StudioDockingEngine";
import {
  useDockingLayout,
  useDockingRuntime,
} from "./DockingContext";
import DockPanelHost from "./DockPanelHost";
import DockSplitPane from "./DockSplitPane";
import DockTabGroup from "./DockTabGroup";


export default function DockingHost({
  registry,
}) {
  const validatedRegistry =
    assertDockPanelRegistry(registry);
  const runtime = useDockingRuntime();
  const layout = useDockingLayout();

  const renderNode = useCallback(
    (node) => {
      if (node.type === DOCK_NODE_TYPES.PANEL) {
        const panel = validatedRegistry.get(node.panelId);

        return (
          <DockPanelHost
            panel={panel}
            onClose={runtime.closePanel}
            onHide={runtime.hidePanel}
          />
        );
      }

      if (node.type === DOCK_NODE_TYPES.TABS) {
        return (
          <DockTabGroup
            node={node}
            registry={validatedRegistry}
            onActivate={runtime.activatePanel}
            onClose={runtime.closePanel}
            onHide={runtime.hidePanel}
          />
        );
      }

      return (
        <DockSplitPane
          node={node}
          renderNode={renderNode}
        />
      );
    },
    [
      runtime,
      validatedRegistry,
    ],
  );

  return (
    <section
      className="studio-docking-host"
      data-dock-layout-id={layout.id}
    >
      {renderNode(layout.root)}
    </section>
  );
}


DockingHost.propTypes = {
  registry: PropTypes.shape({
    get: PropTypes.func.isRequired,
    has: PropTypes.func.isRequired,
    list: PropTypes.func.isRequired,
  }).isRequired,
};
